import { useEffect, useRef } from 'react';
export default function usePrevious(state) {
    var ref = useRef();
    useEffect(function () {
        ref.current = state;
    });
    return ref.current;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/usePrevious.js
// module id = PFCq
// module chunks = 0